module.exports = __webpack_public_path__ + "media/images/icons/stories-28826f2b9c6fb220433fbda3d690f5f0.svg";